import React from 'react';
const rows = [{
  label: 'Preparazione',
  icon: '⏳',
  before: 'Stress: Passi ore a cercare materiale e preparare lezioni.',
  after: 'Lezioni già pronte: Apri il tablet e hai tutto strutturato.'
}, {
  label: 'Coinvolgimento',
  icon: '🥱',
  before: 'Noia: Lezioni ripetitive che fanno perdere interesse agli studenti.',
  after: "Attività coinvolgenti: Materiale visivo e interattivo che cattura l'attenzione."
}, {
  label: 'Pratica',
  icon: '🧪',
  before: 'Teoria: Difficoltà a organizzare esperimenti senza una guida chiara.',
  after: 'Laboratori guidati: Protocolli pronti passo-passo per ogni esperimento.'
}, {
  label: 'Valutazione',
  icon: '📝',
  before: 'Ansia: Dover creare verifiche da zero ogni volta.',
  after: "Verifiche immediate: Test e schede di valutazione già pronti all'uso."
}, {
  label: 'Pianificazione',
  icon: '📅',
  before: 'Caos: Poca organizzazione nel programma annuale.',
  after: 'Percorso organizzato: Un anno scolastico pianificato nei minimi dettagli.'
}];
const bottomStats = [{
  num: '+150h',
  label: 'Risparmiate',
  icon: '⏱️'
}, {
  num: '5 Tomi',
  label: 'Completi',
  icon: '📚'
}, {
  num: '+300',
  label: 'Attività',
  icon: '🧪'
}, {
  num: '100%',
  label: 'Scuola Italiana',
  icon: '🎯'
}];
export function ContrastSection() {
  return <section className="w-full bg-bg-main py-20 px-4 relative overflow-hidden" data-id="element-61">
      <div className="absolute top-20 -left-20 w-[400px] h-[400px] bg-primary/10 rounded-full blur-[120px] pointer-events-none" data-id="element-62"></div>
      <div className="absolute bottom-20 -right-20 w-[400px] h-[400px] bg-secondary/10 rounded-full blur-[120px] pointer-events-none" data-id="element-63"></div>

      <div className="max-w-5xl mx-auto relative z-10" data-id="element-64">
        <div className="text-center mb-14" data-id="element-65">
          <span className="inline-flex items-center gap-2 bg-primary/10 border border-primary/20 text-primary font-bold uppercase tracking-wider text-xs sm:text-sm px-4 py-1.5 rounded-full mb-5" data-id="element-66">
            <span data-id="element-67">⚡</span> La Trasformazione
          </span>
          <h2 className="text-3xl sm:text-5xl font-montserrat font-black text-text-main mb-4 tracking-tight leading-[1.1]" data-id="element-68">
            Da docente sovraccarico a{' '}
            <span className="relative inline-block" data-id="element-69">
              <span className="relative z-10 text-primary" data-id="element-70">
                insegnante organizzato
              </span>
              <span className="absolute bottom-1 left-0 w-full h-3 bg-secondary/30 -z-0 rounded-full" data-id="element-71"></span>
            </span>{' '}
            e sicuro.
          </h2>
        </div>

        <div className="grid grid-cols-2 gap-4 sm:gap-6 mb-5" data-id="element-72">
          <div className="text-center" data-id="element-73">
            <span className="inline-flex items-center gap-2 text-badge-red font-black uppercase tracking-wider text-[10px] sm:text-sm" data-id="element-74">
              <span className="w-1.5 h-1.5 sm:w-2 sm:h-2 rounded-full bg-badge-red" data-id="element-75"></span>
              <span className="hidden sm:inline" data-id="element-76">Senza BIOLOGIA PRONTA™</span>
              <span className="sm:hidden" data-id="element-77">Senza</span>
            </span>
          </div>
          <div className="text-center" data-id="element-78">
            <span className="inline-flex items-center gap-2 text-primary font-black uppercase tracking-wider text-[10px] sm:text-sm" data-id="element-79">
              <span className="w-1.5 h-1.5 sm:w-2 sm:h-2 rounded-full bg-primary" data-id="element-80"></span>
              <span className="hidden sm:inline" data-id="element-81">Con BIOLOGIA PRONTA™</span>
              <span className="sm:hidden" data-id="element-82">Con il Kit</span>
            </span>
          </div>
        </div>

        <div className="space-y-4 sm:space-y-5 mb-14" data-id="element-83">
          {rows.map((row, i) => <div key={i} className="relative grid grid-cols-2 gap-3 sm:gap-6 items-stretch group" data-id="element-84">
              <div className="absolute -top-3 left-1/2 -translate-x-1/2 z-20 hidden sm:flex items-center gap-2 bg-bg-alt border border-border-light rounded-full px-4 py-1 shadow-md" data-id="element-85">
                <span className="text-base" data-id="element-86">{row.icon}</span>
                <span className="text-text-main font-black text-xs uppercase tracking-wider" data-id="element-87">
                  {row.label}
                </span>
              </div>

              <div className="relative bg-bg-alt border border-badge-red/15 rounded-2xl p-5 sm:p-6 overflow-hidden" data-id="element-88">
                <div className="absolute inset-0 bg-gradient-to-br from-badge-red/[0.04] to-transparent pointer-events-none" data-id="element-89"></div>
                <div className="sm:hidden flex items-center gap-1.5 mb-2" data-id="element-90">
                  <span className="text-base" data-id="element-91">{row.icon}</span>
                  <span className="text-badge-red font-black text-[10px] uppercase tracking-wider" data-id="element-92">
                    {row.label}
                  </span>
                </div>
                <div className="relative flex items-start gap-3" data-id="element-93">
                  <div className="w-6 h-6 sm:w-7 sm:h-7 rounded-full bg-badge-red/15 border border-badge-red/30 flex items-center justify-center flex-shrink-0 mt-0.5" data-id="element-94">
                    <span className="text-badge-red font-black text-xs sm:text-sm" data-id="element-95">
                      ✕
                    </span>
                  </div>
                  <p className="text-text-sec text-sm sm:text-base font-medium leading-relaxed" data-id="element-96">
                    {row.before}
                  </p>
                </div>
              </div>

              <div className="relative bg-gradient-to-br from-primary/8 via-bg-alt to-bg-alt border border-primary/30 rounded-2xl p-5 sm:p-6 overflow-hidden shadow-[0_8px_24px_-12px_rgba(30,142,90,0.2)]" data-id="element-97">
                <div className="absolute inset-0 bg-gradient-to-br from-primary/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none" data-id="element-98"></div>
                <div className="sm:hidden flex items-center gap-1.5 mb-2" data-id="element-99">
                  <span className="text-base" data-id="element-100">{row.icon}</span>
                  <span className="text-primary font-black text-[10px] uppercase tracking-wider" data-id="element-101">
                    {row.label}
                  </span>
                </div>
                <div className="relative flex items-start gap-3" data-id="element-102">
                  <div className="w-6 h-6 sm:w-7 sm:h-7 rounded-full bg-check-green/15 border border-check-green/40 flex items-center justify-center flex-shrink-0 mt-0.5" data-id="element-103">
                    <span className="text-check-green font-black text-xs sm:text-sm" data-id="element-104">
                      ✓
                    </span>
                  </div>
                  <p className="text-text-main text-sm sm:text-base font-bold leading-relaxed" data-id="element-105">
                    {row.after}
                  </p>
                </div>
              </div>
            </div>)}
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-4 gap-3 sm:gap-6" data-id="element-106">
          {bottomStats.map((s, i) => <div key={i} className="relative bg-bg-alt border border-primary/20 rounded-2xl p-4 sm:p-6 text-center overflow-hidden group hover:border-primary/40 transition-colors shadow-sm" data-id="element-107">
              <div className="absolute top-0 left-0 right-0 h-0.5 bg-gradient-to-r from-transparent via-primary to-transparent opacity-60" data-id="element-108"></div>
              <div className="text-xl sm:text-3xl mb-2 sm:mb-3 opacity-80" data-id="element-109">
                {s.icon}
              </div>
              <p className="text-primary font-montserrat font-black text-xl sm:text-3xl mb-1 tracking-tight" data-id="element-110">
                {s.num}
              </p>
              <p className="text-text-sec text-xs sm:text-sm leading-snug font-medium" data-id="element-111">
                {s.label}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}